import classNames from "classnames";
import React, { useContext, useLayoutEffect, useState } from "react";
import default_img from "../assets/images/default_img.svg";
import { ConfigContext } from "../config-provider";
export interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  defaultImg?: string;
}
/**
 * 1. 判断是否在可视区内
 * 2. 加载图片
 * 3. 判断是否支持IntersectionObserver，不支持则直接显示
 * 4. 必须在浏览器端，服务端不需要懒加载图片
 */
// 创建监听器
const intersectionObserver = new IntersectionObserver(
  function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        // @ts-ignore
        entry?.target?.loadSrc();
      }
    });
  },
  {
    // root: document.getElementById("root"),
  }
);

const LazyImage: React.FunctionComponent<LazyImageProps> = props => {
  const { src = "", className, style, defaultImg = default_img, ...rest } = props;
  const [imgSrc, setImgSrc] = useState<string>(defaultImg);
  const [error, setError] = useState(false);
  const { getPrefixCls } = useContext(ConfigContext);
  const [imgRef, setImgRef] = useState<HTMLImageElement>(null);
  const [fill, setFill] = useState(true);
  const prefixCls = getPrefixCls("lazy-image");
  const classString = classNames(prefixCls, className);
  const extraStyle: React.CSSProperties = {};
  if (fill) {
    extraStyle.objectFit = "fill";
    extraStyle.fill = "#ECEEF0";
  }
  useLayoutEffect(() => {
    if (!intersectionObserver) {
      setImgSrc(src);
    } else {
      if (!!imgRef && !!src) {
        (imgRef as any).loadSrc = () => {
          setImgSrc(src);
          intersectionObserver?.unobserve(imgRef);
        };
        intersectionObserver?.observe(imgRef);
      }
    }
    return () => imgRef && intersectionObserver?.unobserve(imgRef);
  }, [src, imgRef]);
  return (
    <img
      style={{ ...style, ...extraStyle }}
      ref={setImgRef}
      className={classString}
      src={error ? default_img : imgSrc}
      onError={() => setError(true)}
      {...rest}
    />
  );
};

export default LazyImage;
